import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'read-only-field',
  templateUrl: './read-only-field.component.html',
  styleUrls: ['./read-only-field.component.scss']
})
export class ReadOnlyFieldComponent {

}
